
export default {
    methods: {
        createBus(eventName, fn) {
            this.$bus.$on(eventName, fn)
            this.$once('hook:beforeDestroy', ()=> {
                this.$bus.$off(eventName, fn)
            })
        }
    }
    
}